function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0H50V50H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M36.043 9H5.29a1.3 1.3 0 0 0-.913.372 1.255 1.255 0 0 0-.377.9V36.9a1.255 1.255 0 0 0 .377.9 1.3 1.3 0 0 0 .913.372h30.753a1.3 1.3 0 0 0 .913-.372 1.255 1.255 0 0 0 .376-.9V10.27a1.255 1.255 0 0 0-.377-.9 1.3 1.3 0 0 0-.912-.37zm-24.822 3.646a2.788 2.788 0 0 1 2.579 1.681 2.7 2.7 0 0 1-.6 2.984 2.824 2.824 0 0 1-3.038.6 2.728 2.728 0 0 1 1.053-5.263zm24.815 24a.419.419 0 0 1-.126.3.435.435 0 0 1-.309.124H5.732a.435.435 0 0 1-.309-.124.419.419 0 0 1-.126-.3v-3.98a.422.422 0 0 1 .112-.288l1.156-1.248 5.181-5.6a.44.44 0 0 1 .641 0l4.71 5.1a.436.436 0 0 0 .67-.025l1.862-2.369 6.594-8.4a.429.429 0 0 1 .649-.039.186.186 0 0 1 .036.039l3.225 4.1 3.367 4.289 1.812 2.294.649.825a.429.429 0 0 1 .091.263z",
  transform: "translate(4.333 2.111)"
});

function SvgIconImages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImages);
export default __webpack_public_path__ + "static/media/icon_images.4cfbcf2a.svg";
export { ForwardRef as ReactComponent };